import PackingType from "../../Models/PackingType";
import {ValueType} from "../../Models/ValueType";

export const GET_PACKING_TYPES = "PackingType/getPackingTypes";
export const SET_PACKING_TYPES = "PackingType/setPackingTypes";

export interface PackingTypeReducerType {
  packingTypes: PackingType[];
  packingTypesOptionList: ValueType[];
}
